export default {
    height: '100%',
    borderRadius: 10,
    control: {
        backgroundColor: "#fff",

        fontSize: 15,
        fontWeight: "normal"
    },

    highlighter: {
        overflow: "hidden"
    },

    input: {
        margin: 0,
    },

    // "&singleLine": {
    //     control: {
    //         display: "inline-block",
    //         fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    //         width: 130
    //     },

    //     highlighter: {
    //         padding: 1,
    //         border: "2px inset transparent"
    //     },

    //     input: {
    //         padding: 1,

    //         border: "2px inset"
    //     }
    // },

    "&multiLine": {
        control: {
            // fontFamily: "monospace",
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            height: '100%',
            border: "1px solid silver",
            borderRadius: 10
        },

        highlighter: {
            padding: 9,
            fontWeight: 'bold',
        },

        input: {
            padding: 9,
            // minHeight: 63,
            outline: 0,
            border: 0,
            maxHeight: 100,
            overflow: 'auto',
            position: 'absolute',
            width: '100%',
            bottom: 14,
        }
    },

    suggestions: {
        list: {
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            backgroundColor: "white",
            border: "1px solid rgba(0,0,0,0.15)",
            fontSize: 15,
            height: 120,
            maxHeight: 120,
            overflow: 'auto'
        },

        item: {
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            padding: "5px 15px",
            borderBottom: "1px solid rgba(0,0,0,0.15)",

            "&focused": {
                backgroundColor: "#D3D3D3"
            }
        }
    }
};
